module.exports = __webpack_public_path__ + "img/xcx.a14450b7.jpg";